import * as React from 'react';
import { Fieldset as FieldsetStandard } from '@emorg-prd/standard-react';

interface FieldsetProps extends Omit<React.ComponentProps<typeof FieldsetStandard>, 'twoColumned'> {
	legend: string;
	twoColumned?: boolean;
	optionalClass?: string;
	children: React.ReactNode;
}

const Fieldset: React.FC<FieldsetProps> = (props) => {
	const { legend, twoColumned, optionalClass, children, ...rest } = props;

	return (
		<FieldsetStandard
			{...rest}
			legend={legend}
			twoColumned={twoColumned}
			optionalClass={optionalClass}
		>
			{children}
		</FieldsetStandard>
	);
};

export { Fieldset };
